import React, { useContext } from 'react';
import FitGuideSlidesContext from './FitGuideSlidesContext';
const NO_SLIDES = [];

// Empty without FitGuideSlidesServerBoundary in the tree
const useFitGuideSlides = () => {
  const value = useContext(FitGuideSlidesContext);
  const slides = value && typeof value.then === "function" ? React.use(value) : value;
  return Array.isArray(slides) ? slides : NO_SLIDES;
};
export default useFitGuideSlides;